module.exports = __webpack_public_path__ + "static/media/img_panel_tenants.61d6a8bd.jpg";